import React, { useState, useEffect, useMemo, useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import BaseURL from "../../../../utils/base-uri.json";
import axios from "../../../../utils/fvAxios";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Typography } from "@mui/material";
import * as Yup from "yup";
import Select from "@mui/material/Select";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { InputAdornment } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import fileDownload from "js-file-download";
import "./UploadUser.css";
import VariableSizeSelect from "../../../../utils/VariableSizeSelect";
import PromptDialog from "../../../../components/PromptDialog";
import ErrorAlert from "../../../../toolkit/ErrorAlert";
import AutoCompleteVariableSize from "../../../../utils/AutoCompleteVariableSize";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const allowedFileTypes = ["application/excel", "application/csv"];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 220,
    },
  },
};
const toastNotify = (message, isSuccess = true, isInfo = false) => {
  if (isInfo) {
    toast.info(message, {
      position: "top-right",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};
export default function UploadUser(props) {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(false);
  const [isVisibleUnsavedDetails, setIsVisibleUnsavedDetails] = useState(false);

  const [orgTypes, setOrgTypes] = useState([
    { value: "-1", text: "Select Organization Type", selected: false },
  ]);
  const [organizations, setOrganizations] = useState([
    { value: "-2", text: "Select Organization", selected: false },
  ]);
  const [roles, setRoles] = useState([
    { value: "-1", text: "Select Role", selected: false },
  ]);
  const [orgType, setOrgType] = useState(-1);
  const [organization, setOrganization] = useState(-2);
  const [role, setRole] = useState(-1);
  const [departmentId, setDepartmentId] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [showPrompt, setShowPrompt] = useState(false);
  const [uploadResponse, setResponse] = useState(null);

  useEffect(() => {
    GetDetailsToAddUser();
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleOrgTypeChange = (event) => {
    setOrgType(event.target.value);
    setOrganization(-2);

    if (event.target.value != -1) {
      const _orgType =
        orgTypes.find((obj) => obj.value == event.target.value) ?? {};
      //getRolesForOrgType(_orgType.text);
      GetOrganizationsList(event.target.value);
    }
  };
  const getClientDepartments = async (clientId) => {
    const response = await axios.get(
      BaseURL.Users.GetClientDepartments + `clientId=${clientId}`
    );

    if (response.data?.data) {
      setDepartments(response.data.data);

      setTimeout(() => console.log(departments), 900);
    }
  };
 const handleChange1 = (selectedValue) => {
    setOrganization(selectedValue);
    if (orgType == 1) {
      getClientDepartments(selectedValue);
    }
  };
  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };
  const ChangeDepartment = (event) => {
    setDepartmentId(event.target.value);
  };

  const handleDownload = (e) => {
    axios
      .get(
        BaseURL.baseUrl +
          BaseURL.settings.UploadUserTemplate +
          "?fileName=UploadUsers",
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        fileDownload(res?.data, "UploadUsers.csv");
      });
  };
  const getRolesForOrgType = (orgType) => {
    axios
      .get(BaseURL.settings.GetOrganizationRoles + "?orgType=" + orgType)
      .then((res) => {
        if (res?.data?.status == false) console.error(res?.data);
        if (res.data?.data) {
          let ROLES = res.data.data?.map((role) => {
            return {
              value: role.value,
              text: role.text,
            };
          });
          setRoles(ROLES);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getRolesInCompany = (orgId) => {
    axios
      .get(BaseURL.settings.GetOrganizationRoles + "?orgId=" + orgId)
      .then((res) => {
        if (res?.data?.status == false) console.error(res?.data);
        if (res.data?.data) {
          let ROLES = res.data.data?.map((role) => {
            return {
              value: role.value,
              text: role.text,
            };
          });
          setRoles(ROLES);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const GetOrganizationsList = async (orgType) => {
    setCompaniesLoading(true);
    const response = await axios.get(
      BaseURL.settings.GetOrganizationsList + "?userType=" + orgType
    );

    if (response.data?.data) {
      setOrganizations(
        response.data.data?.map((r) => ({
          value: r.value,
          text: r.text,
          selected: r.selected,
        }))
      );
      setCompaniesLoading(false);
    }
  };

  const GetDetailsToAddUser = async () => {
    const response = await axios.get(BaseURL.settings.GetDetailsToAddUser);

    if (response.data?.data) {
      setOrgTypes(
        response.data.data?.orgTypes?.map((r) => ({
          value: r.value,
          text: r.text,
          selected: r.selected,
        }))
      );
      // setOrganizations(
      //   response.data.data?.organizations?.map((r) => ({
      //     value: r.value,
      //     text: r.text,
      //     selected: r.selected,
      //   }))
      // );
    }
  };
  const onSubmit = async (data) => {
    setError(null);
    if (!selectedFile) {
      toastNotify("Please upload a valid CSV File", false);
      return;
    }

    if (selectedFile && role && organization && orgType > -1) {
      setIsSaving(true);

      const formData = new FormData();
      formData.append("CSVFile", selectedFile);
      formData.append("organizationId", organization);
      formData.append("roleId", role);
      formData.append("organizationType", 0);
      formData.append("departmentId", orgType == 1 ? departmentId : 0); // when client

      const response = await axios.post(
        BaseURL.baseUrl + BaseURL.settings.UploadBulkUsers,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );


      if (response.data?.responseMessage === "Success") {
        setIsSaving(false);

        const _data = response.data?.data;
        if (!_data) {
          toastNotify(response.data?.responseMessage, false);
          return;
        }
        const savedUsersCount = _data.insertedUsers?.length || 0;
        const unsavedUsersCount = _data.errorsForUser?.length || 0;

        // if (savedUsersCount > 0 && unsavedUsersCount === 0) {
        //   toastNotify(
        //     `${savedUsersCount} Saved ${
        //       savedUsersCount === 1 ? "User" : "Users"
        //     }`,
        //     true
        //   );
        // } else {
        //   toastNotify(
        //     `${savedUsersCount} Saved ${
        //       savedUsersCount === 1 ? "User" : "Users"
        //     }`,
        //     true,
        //     savedUsersCount === 0
        //   );
        //   toastNotify(
        //     `${unsavedUsersCount} 'UnSaved' ${
        //       unsavedUsersCount === 1 ? "User" : "Users"
        //     }`,
        //     true,
        //     true
        //   );
        // }
        setShowPrompt(true);
        setResponse(_data);       

        // if (_data.insertedUsers?.length > 0) {
        //   setTimeout(() => {
        //     navigate("/SearchUser");
        //   }, 1500);
        // }
      } else if (response.data?.responseCode == -100) {
        // toastNotify(response.data?.responseMessage, false);
        setError(response.data?.responseMessage)
      } else if (response.data?.responseCode == -200) {
        const errorMessages = Object.entries(response.data.error).map(
          ([fieldName, messages]) => {
            return `${fieldName}: ${messages.join(", ")}`;
          }
        );

        toastNotify(errorMessages.join(" | "), false);
        
      } else console.error(response.data);
      setIsSaving(false);
    } else toastNotify("Please fill required fields", false);
  };
  function handleFileInput(event) {
    const incomingFile = event.target.files[0];
    if (incomingFile !== undefined) {
      if (incomingFile.size > MAX_FILE_SIZE) {
        // setMessageValidate(false);
        // setValidationMessage("File size should be less than 10 MB");
        event.target.value = null;
        setSelectedFile(null);
        return;
      } else if (!allowedFileTypes.includes(incomingFile.type)) {
        // setMessageValidate(false);
        // setValidationMessage("Invalid file type");
        event.target.value = null;
        setSelectedFile(null);
        return;
      }

      setSelectedFile(incomingFile);
    }
  }
  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file.type === "text/csv" && file.size <= MAX_FILE_SIZE) {
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedFile(file);
        //   setSelectedImagePath(file.preview)
      };
      reader.readAsDataURL(file);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    } else {
      // File type or size is not valid
      if (file.size >= MAX_FILE_SIZE)
        toastNotify("Can't upload larger than 10 MB file", false);
      else toastNotify("Invalid file", false);
      // Display an error message or perform appropriate actions
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: { "text/csv": [] },
  });

  const style = useMemo(
    () => ({
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const thumbs = files.map((file) => <div key={file.name}>{file.name}</div>);
  // clean up
  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.name));
    },
    [files]
  );
  const Cancel = () => {
    props.close(true);
  };
  const { t } = useTranslation();
  const handleOnConfirm = () => {
    setShowPrompt(false);
    navigate("/SearchUser");
  };
  const unsavedUserHandler = () => {
    setIsVisibleUnsavedDetails(true);
  };
  return (
    <>
      {showPrompt && (
        <PromptDialog
          closeButtonText={"Try Again"}
          open={showPrompt}
          onClose={() => {
            setShowPrompt(false);
            setIsVisibleUnsavedDetails(false);
          }}
          onConfirm={handleOnConfirm}
          Title="Upload Summary"
        >
          {uploadResponse?.insertedUsers?.length > 0 && <ErrorAlert
            className="border"
            severity="success"
            // message={`Saved Users: ${uploadResponse?.insertedUsers?.length ?? 0}`}
            message={"Users have been saved successfully"}
          />}
         
          {/* <ErrorAlert
            className="border"
            severity="success"
            // message={`Saved Users: ${uploadResponse?.insertedUsers?.length ?? 0}`}
            message={`${uploadResponse?.insertedUsers?.length ?? "Users have been saved successfully"}`}
          />
          <ol>
            {uploadResponse?.insertedUsers?.map((user, index) => (
              <li key={index}>
                <u>{user}</u>
              </li>
            ))}
          </ol> */}
          {/* <ErrorAlert
            className="border"
            severity="error"
            // message={`Unsaved Users: ${uploadResponse?.errorsForUser?.length ?? 0}`}
            message={`${
              uploadResponse?.errorsForUser?.length ?? 0
            } Unsaved Users ${(
              <span onClick={unsavedUserHandler}>Details</span>
            )}`}
          /> */}
          {uploadResponse?.errorsForUser?.length > 0 && <ErrorAlert
            className="border"
            severity="error"
            message={
              <React.Fragment>
                {uploadResponse?.errorsForUser?.length ?? 0} Unsaved Users{" "}
                <span className="underlined" onClick={unsavedUserHandler}>Details</span>
              </React.Fragment>
            }
          />}
          {isVisibleUnsavedDetails &&
          (<> 
          <p>Errors:</p>      
            <ol>
              {uploadResponse?.errorsForUser?.map((error, index) => {
                const email = Object.keys(error)[0];
                const errorMessage = Object.values(error)[0][0];
                return (
                  <li key={index}>
                    <u>{email}</u>: {errorMessage}
                  </li>
                );
              })}
            </ol>
            </>
          )}
        </PromptDialog>
      )}
      <DialogContent
        sx={{ padding: "40px 48px", overflowX: "hidden" }}
        className="pb-1"
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 20,
          }}
        >
          Upload Users
        </DialogTitle>
        {error && (
          <ErrorAlert className="border" severity="error" message={error} />
        )}
        <span className="username-label mx-2 mt-2" style={{ color: "#3E4A62" }}>
          User Organization Type <span className="red-color">*</span>
        </span>
        <Select
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
          }}
          value={orgType}
          required
          size="small"
          placeholder="Organization Type"
          name="Organizationtype"
          id="Organizationtype"
          className="form-control text-feild-custom mx-2"
          {...register("OrganizationType")}
          onChange={handleOrgTypeChange}
        >
          {orgTypes?.map((r, index) => (
            <MenuItem key={index} value={r.value}>
              {r.text}
            </MenuItem>
          ))}
        </Select>
        <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
          Company <span className="red-color">*</span>
        </span>

        {/* <VariableSizeSelect
          options={organizations}
          isLoading={companiesLoading}
          handleChange={handleChange1}
          defaultValue={organization}
          name="Company"
          defaultValueObj={{text:"Select Organization", value:-2}}
        /> */}
        <AutoCompleteVariableSize
          options={organizations}
          isLoading={companiesLoading}
          selectedOption={organization}
          name="Company"
          defaultOption={{ text: "Select Organization", value: -2 }}
          handleChange={handleChange1}
        />
        <Typography className="text-danger mx-2 mt-1">
          {errors.Company?.message}
        </Typography>

        {orgType == 1 && ( //when client
          <>
            <span
              style={{ color: "#3E4A62" }}
              className="username-label mx-2 mt-2"
            >
              Department
            </span>
            <Select
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={departmentId}
              required
              size="small"
              placeholder="Department"
              name="department"
              id="department"
              className="form-control text-feild-custom mx-2 border-0"
              onChange={ChangeDepartment}
            >
              {departments?.map((r, index) => (
                <MenuItem key={index} value={r.value}>
                  {r.key}
                </MenuItem>
              ))}
            </Select>
          </>
        )}
        <span style={{ color: "#3E4A62" }} className="username-label mx-2 mt-2">
          CSV File <span className="red-color">*</span>
        </span>
        {selectedFile && selectedFile.value}
        <div
          className="drop p-1 d-flex mx-2 py-3 align-items-center justify-content-center rounded border-dashed"
          {...getRootProps({ style })}
        >
          <input {...getInputProps()} />

          {selectedFile ? (
            // <img height={100} width={100} src={`data:image/${imageFormat};base64,${selectedImagePath}`} alt="Uploaded" />
            <span></span>
          ) : (
            <>
              <br />
              <span className="text-muted fs">
                <b>
                  <span className="mx-1 cl">
                    {t("DragandDrop.firstLabel1")}
                  </span>
                  {t("DragandDrop.firstLabel2")}
                </b>
              </span>
              <br />
              {/* <span className=" text-muted Fs">
                    {t("DragandDrop.secondLabel")}
                  </span> */}
            </>
          )}
          <span className=" text-muted Fs"> {thumbs}</span>
        </div>

        <div className="d-flex mt-2">
          <Button
            variant="contained"
            className="mx-2 w-100 bg-primary-light py-3"
            onClick={handleDownload}
          >
            Download CSV Template
          </Button>
        </div>
      </DialogContent>
      <DialogActions className="pb-5 ">
        <div className="login-help__buttonContainer d-flex gap-2 align-items-center px-5">
          <Button
            variant="contained"
            className="w-50 bg-primary-light py-3"
            onClick={Cancel}
          >
            Cancel
          </Button>
          {isSaving ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button
              variant="contained"
              className="primary w-50 py-3"
              onClick={handleSubmit(onSubmit)}
            >
              Next
            </Button>
          )}
        </div>
      </DialogActions>
    </>
  );
}
